import React from "react";
import PropTypes from "prop-types";
import "./SearchTab.scss";

/**
 * Search Tab component for switching between brands and members
 * @param activeTab - Current active tab ('brand' or 'member')
 * @param onTabChange - Function to handle tab change
 * @returns {JSX.Element}
 * @constructor
 */
export default function SearchTab({ activeTab, onTabChange }) {
  return (
    <div className="SearchTab">
      <div
        className={`SearchTab-item ${activeTab === "BRAND" ? "active" : ""}`}
        onClick={() => onTabChange("BRAND")}
      >
        브랜드
      </div>
      <div
        className={`SearchTab-item ${activeTab === "SELLER" ? "active" : ""}`}
        onClick={() => onTabChange("SELLER")}
      >
        멤버
      </div>
    </div>
  );
}

SearchTab.propTypes = {
  activeTab: PropTypes.oneOf(["BRAND", "SELLER"]).isRequired,
  onTabChange: PropTypes.func.isRequired,
};
